import { benefit, business, lunch, blue, giftCard } from 'theme/colors';

export const SIDE_NAV_WIDTH = '16.5rem';
export const TOP_NAV_HEIGHT = '4.5rem';

export type ProductName = 'Beneficio' | 'Corporativo' | 'Almuerzo' | 'Gobierno' | 'GiftCard';

export const ProductsAvailable: Record<ProductName, ProductName> = {
  Beneficio: 'Beneficio',
  Corporativo: 'Corporativo',
  Almuerzo: 'Almuerzo',
  Gobierno: 'Gobierno',
  GiftCard: 'GiftCard',
};

export type ProductsAvailablesColors = {
  name: ProductName;
  colors?: {
    main: string;
  };
};

export interface ProductColor {
  main: string;
  light?: string;
  dark?: string;
  contrastText: string;
}

export const PRODUCTS_COLORS: Record<ProductName, ProductColor> = {
  Beneficio: benefit,
  Corporativo: business,
  Almuerzo: lunch,
  Gobierno: blue,
  GiftCard: giftCard,
};
